// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const firebaseConfig = {
  apiKey: "AIzaSyD-c-bLZTU51mwyt5a0XeXasudraXc7Rmo",
  authDomain: "strategy-sports-network.firebaseapp.com",
  projectId: "strategy-sports-network",
  storageBucket: "strategy-sports-network.appspot.com",
  messagingSenderId: "141041928447",
  appId: "1:141041928447:web:de31191ea6fc90ad01a4ca",
  measurementId: "G-R6XEKSFZ2C"
};